export const en = {
  delete: 'Delete',
  disable: 'Disable',
  enable: 'Enable',
  confirmDelete: 'Really delete?',
  moreActions: 'More actions',
  readAll: 'Mark all comments as read'
};
export type Translations = typeof en;
